import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import "./PinnacleRoute.css";
import mandaeanAppImage from "../assets/mandean.jpeg";
import designerClubImage from "../assets/designerclub.jpeg";
import iconicJewelryImage from "../assets/iconicjwel.jpeg";
import borrowedLuxeHireImage from "../assets/borrowedluxehire.png";

const brandLogoFiles = [
  "Gemini_Generated_Image_1q6rmu1q6rmu1q6r.png",
  "Gemini_Generated_Image_286tvw286tvw286t.png",
  "Gemini_Generated_Image_45nv8g45nv8g45nv.png",
  "Gemini_Generated_Image_4empju4empju4emp.png",
  "Gemini_Generated_Image_5zte9n5zte9n5zte.png",
  "Gemini_Generated_Image_83l28o83l28o83l2.png",
  "Gemini_Generated_Image_8a1lp58a1lp58a1l.png",
  "Gemini_Generated_Image_92tue592tue592tu.png",
  "Gemini_Generated_Image_9wx1ln9wx1ln9wx1.png",
  "Gemini_Generated_Image_a13f7ca13f7ca13f.png",
  "Gemini_Generated_Image_c3exvvc3exvvc3ex.png",
  "Gemini_Generated_Image_fbgw9afbgw9afbgw.png",
  "Gemini_Generated_Image_gjr699gjr699gjr6.png",
  "Gemini_Generated_Image_goy4pogoy4pogoy4.png",
  "Gemini_Generated_Image_gy87gbgy87gbgy87.png",
  "Gemini_Generated_Image_iqtpz0iqtpz0iqtp.png",
  "Gemini_Generated_Image_j1f2fyj1f2fyj1f2.png",
  "Gemini_Generated_Image_j89q5dj89q5dj89q.png",
  "Gemini_Generated_Image_k2ayhek2ayhek2ay.png",
  "Gemini_Generated_Image_ntnzxjntnzxjntnz.png",
  "Gemini_Generated_Image_p97rnxp97rnxp97r.png",
  "Gemini_Generated_Image_pqgo00pqgo00pqgo.png",
  "Gemini_Generated_Image_qi4jwlqi4jwlqi4j.png",
  "Gemini_Generated_Image_qowd27qowd27qowd.png",
  "Gemini_Generated_Image_rxe4gsrxe4gsrxe4.png",
  "Gemini_Generated_Image_s4a9ms4a9ms4a9ms.png",
  "Gemini_Generated_Image_s5xbj7s5xbj7s5xb.png",
  "Gemini_Generated_Image_sfi6p5sfi6p5sfi6.png",
  "Gemini_Generated_Image_soq3m5soq3m5soq3.png",
  "Gemini_Generated_Image_ukz5ieukz5ieukz5.png",
  "Gemini_Generated_Image_vn26o3vn26o3vn26.png",
  "Gemini_Generated_Image_vqm38evqm38evqm3.png",
  "Gemini_Generated_Image_xu922ixu922ixu92.png",
  "Gemini_Generated_Image_yd8j90yd8j90yd8j.png",
  "Gemini_Generated_Image_z8d333z8d333z8d3.png",
  "Gemini_Generated_Image_zfo8j7zfo8j7zfo8.png",
];

const testimonialsData = [
  {
    quote:
      '"Pinnacle Route completely transformed our digital presence. Our bookings tripled within the first three months and we\'ve not looked back. They understand the luxury rental space like no one else."',
    name: "Sophia Laurent",
    role: "Founder, Elysian Atelier",
    avatar: "S",
  },
  {
    quote:
      '"The AI automation they built means our team now focuses on curation and styling rather than answering emails. It was the single best investment we made last year."',
    name: "Amelia Chen",
    role: "CEO, The Vault Collective",
    avatar: "A",
  },
  {
    quote:
      '"Finally an agency that gets it. They did not need us to explain how rental works - they already knew. The website they delivered looks like it belongs alongside the brands we carry."',
    name: "Isabelle Moreau",
    role: "Director, Maison Rent Paris",
    avatar: "I",
  },
  {
    quote:
      '"Working with Pinnacle Route was a game-changer for us. The team brought our vision to life with a beautiful, responsive digital experience that truly reflects our identity. They were professional and exceeded every expectation. Highly recommend for anyone serious about digital excellence!"',
    name: "Billy Jaderpour",
    role: "Mandaean Life",
    avatar: "B",
  },
  {
    quote:
      '"Pinnacle Route made the process of creating our fashion platform seamless and inspiring. They combined creativity with technical expertise to deliver a stunning and user-friendly website. Communication was always clear and timely, and the results were even better than we imagined!"',
    name: "Maddie Davies",
    role: "The Designer Club",
    avatar: "M",
  },
  {
    quote:
      '"I could not have asked for a better partner than Pinnacle Route. They understood the elegance and sophistication we needed for our jewelry brand and brought it to life with precision and beauty. Their attention to detail and commitment to quality were outstanding from start to finish."',
    name: "Bashar Saeed",
    role: "Iconic Jewelry",
    avatar: "B",
  },
];

const ourWorkProjects = [
  {
    title: "Mandaean App",
    description:
      "This mobile app is a massive online resource community for Mandaean history, beliefs and events.",
    image: mandaeanAppImage,
    link: "https://mandaeanapp.com.au/",
  },
  {
    title: "The Designer Club",
    description:
      "An Australian platform where users can rent or lend clothes from each other's wardrobes.",
    image: designerClubImage,
    link: "https://thedesignerclub.com.au/",
  },
  {
    title: "Borrowed Luxe Hire",
    description:
      "A premium fashion rental destination focused on luxury looks and seamless online hire experience.",
    image: borrowedLuxeHireImage,
    link: "https://www.borrowedluxehire.com.au/",
  },
  {
    title: "Iconic Jewelry",
    description:
      "An e-commerce platform producing climate-conscious jewelry with a premium brand experience.",
    image: iconicJewelryImage,
    link: "https://www.iconicjewelry.com/",
  },
];

const Home = () => {
  const currentYear = new Date().getFullYear();
  const whatsappStrategyUrl = "https://wa.me/918429283937";
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAuditRequested, setIsAuditRequested] = useState(false);
  const [isSubmittingAudit, setIsSubmittingAudit] = useState(false);
  const [auditError, setAuditError] = useState("");
  const [auditRecaptchaToken, setAuditRecaptchaToken] = useState("");
  const [auditFormData, setAuditFormData] = useState({
    name: "",
    business: "",
    website: "",
    email: "",
    message: "",
  });
  const recaptchaRef = useRef(null);

  const handleAuditInputChange = (e) => {
    const { name, value } = e.target;
    setAuditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAuditCaptchaChange = (token) => {
    setAuditRecaptchaToken(token || "");
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleAuditSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingAudit || isAuditRequested) return;

    setAuditError("");

    if (!auditRecaptchaToken) {
      setAuditError("Please complete the captcha and try again.");
      return;
    }

    setIsSubmittingAudit(true);

    try {
      const payload = {
        name: auditFormData.name,
        email: auditFormData.email,
        phone: "",
        message: `Website Audit Request\nBusiness Name: ${auditFormData.business}\nWebsite URL: ${auditFormData.website}\nAdditional Message: ${auditFormData.message}`,
        token: auditRecaptchaToken,
      };

      const res = await fetch(
        "https://main-backend-eta.vercel.app/api/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        throw new Error("Failed to submit audit request");
      }

      setIsAuditRequested(true);
      setAuditFormData({
        name: "",
        business: "",
        website: "",
        email: "",
        message: "",
      });
      setAuditRecaptchaToken("");
      recaptchaRef.current?.reset();
    } catch (error) {
      setAuditError("Could not submit right now. Please try again.");
    } finally {
      setIsSubmittingAudit(false);
    }
  };

  useEffect(() => {
    document.title =
      "Pinnacle Route - Digital Solutions for Fashion Rental Brands";
    document.body.classList.add("pinnacle-body");

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    const revealTargets = Array.from(
      document.querySelectorAll(".pinnacle-page .reveal"),
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" },
    );

    revealTargets.forEach((target) => observer.observe(target));

    return () => {
      window.removeEventListener("scroll", handleScroll);
      revealTargets.forEach((target) => observer.unobserve(target));
      observer.disconnect();
      document.body.classList.remove("pinnacle-body");
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="pinnacle-page">
      <nav id="nav" className={isScrolled ? "scrolled" : ""}>
        <a href="#home" className="nav-logo">
          Pinnacle<span>Route</span>
        </a>
        <button
          type="button"
          className="nav-menu-toggle"
          onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>
        <ul className="nav-links">
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#work">Case Studies</a>
          </li>
          <li>
            <a href="#our-work">Our Work</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
          <li>
            <a href="#audit" className="nav-cta">
              Book Strategy Call
            </a>
          </li>
        </ul>
        <ul className={`nav-mobile-links ${isMobileMenuOpen ? "open" : ""}`}>
          <li>
            <a href="#services" onClick={closeMobileMenu}>
              Services
            </a>
          </li>
          <li>
            <a href="#work" onClick={closeMobileMenu}>
              Case Studies
            </a>
          </li>
          <li>
            <a href="#our-work" onClick={closeMobileMenu}>
              Our Work
            </a>
          </li>
          <li>
            <a href="#about" onClick={closeMobileMenu}>
              About
            </a>
          </li>
          <li>
            <a href="#audit" onClick={closeMobileMenu}>
              Contact
            </a>
          </li>
          <li>
            <a href="#audit" className="nav-cta" onClick={closeMobileMenu}>
              Book Strategy Call
            </a>
          </li>
        </ul>
      </nav>

      <section className="hero" id="home">
        <div className="hero-bg" />
        <div className="hero-grid-overlay" />
        <div className="hero-content">
          <div className="hero-left">
            <div className="hero-tag">Digital Agency · Fashion Rental</div>
            <h1>
              Websites &amp; Automation for <em>Fashion Rental</em> Businesses
            </h1>
            <p className="hero-sub">
              We help designer dress, luxury bag, and fashion rental brands
              build premium websites and automated booking systems that convert
              visitors into loyal customers.
            </p>
            <div className="hero-actions">
              <a
                href={whatsappStrategyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Book Free Strategy Call
              </a>
              <a href="#work" className="btn-ghost">
                View Case Studies
              </a>
            </div>
            <div className="hero-stat-strip">
              <div className="hero-stat">
                <span className="stat-num">40+</span>
                <span className="stat-label">Rental Brands Launched</span>
              </div>
              <div className="hero-stat">
                <span className="stat-num">3.2×</span>
                <span className="stat-label">Avg. Booking Increase</span>
              </div>
              <div className="hero-stat">
                <span className="stat-num">98%</span>
                <span className="stat-label">Client Retention Rate</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-frame">
              <div className="hero-mockup">
                <div className="mockup-bar">
                  <div className="mockup-dot d1" />
                  <div className="mockup-dot d2" />
                  <div className="mockup-dot d3" />
                  <div className="mockup-url">elysianrental.com</div>
                </div>
                <div className="mockup-body">
                  <div className="mockup-hero-img" />
                  <div className="mockup-cards">
                    <div className="mockup-card">
                      <div className="mockup-card-line l1" />
                      <div className="mockup-card-line l2" />
                      <div className="mockup-card-line l3" />
                    </div>
                    <div className="mockup-card">
                      <div className="mockup-card-line l1" />
                      <div className="mockup-card-line l2" />
                      <div className="mockup-card-line l3" />
                    </div>
                    <div className="mockup-card">
                      <div className="mockup-card-line l1" />
                      <div className="mockup-card-line l2" />
                      <div className="mockup-card-line l3" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="marquee-wrap">
        <div className="marquee-track">
          <div className="marquee-item">Fashion Rental Websites</div>
          <div className="marquee-item">Automated Booking Systems</div>
          <div className="marquee-item">AI Automation</div>
          <div className="marquee-item">Luxury UX Design</div>
          <div className="marquee-item">SEO for Rental Brands</div>
          <div className="marquee-item">Inventory Management</div>
          <div className="marquee-item">Fashion Rental Websites</div>
          <div className="marquee-item">Automated Booking Systems</div>
          <div className="marquee-item">AI Automation</div>
          <div className="marquee-item">Luxury UX Design</div>
          <div className="marquee-item">SEO for Rental Brands</div>
          <div className="marquee-item">Inventory Management</div>
        </div>
      </div>

      <section className="expertise">
        <div className="section-inner">
          <div className="expertise-grid">
            <div className="expertise-left reveal">
              <div className="section-tag">Industry Expertise</div>
              <h2 className="section-title">
                Built for <em>Fashion Rental</em> Brands
              </h2>
              <p className="expertise-desc">
                Pinnacle Route is not a generalist web agency. We have spent
                years working exclusively within the fashion rental industry,
                understanding the unique challenges of inventory management,
                booking logistics, customer expectations, and luxury brand
                presentation.
              </p>
              <div className="expertise-pills">
                <span className="pill">Dress Rental Websites</span>
                <span className="pill">Luxury Bag Platforms</span>
                <span className="pill">Booking Systems</span>
                <span className="pill">AI Automation</span>
                <span className="pill">Shopify Development</span>
                <span className="pill">Custom Web Apps</span>
                <span className="pill">CRM Integration</span>
                <span className="pill">SEO &amp; Growth</span>
              </div>
            </div>
            <div className="expertise-right">
              <div className="exp-card reveal reveal-delay-1">
                <div className="exp-icon">👗</div>
                <h4>Dress Rental Websites</h4>
                <p>
                  Premium digital storefronts that showcase your collection with
                  editorial-quality design and seamless booking flow.
                </p>
              </div>
              <div className="exp-card reveal reveal-delay-2">
                <div className="exp-icon">👜</div>
                <h4>Luxury Bag Platforms</h4>
                <p>
                  High-end e-commerce experiences built for luxury handbag and
                  accessory rental businesses.
                </p>
              </div>
              <div className="exp-card reveal reveal-delay-3">
                <div className="exp-icon">✨</div>
                <h4>AI-Powered Automation</h4>
                <p>
                  Intelligent systems that handle bookings, customer queries,
                  and operations automatically around the clock.
                </p>
              </div>
              <div className="exp-card reveal reveal-delay-4">
                <div className="exp-icon">📈</div>
                <h4>Conversion Optimisation</h4>
                <p>
                  Data-driven UX strategies that turn browsers into bookers and
                  bookers into loyal repeat customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="brand-logos-strip">
        <div className="section-inner">
          <p className="brand-logos-title">
            Technologies &amp; AI Tools We Use
          </p>
          <div className="brand-logos-carousel">
            <div className="brand-logos-track">
              {[...brandLogoFiles, ...brandLogoFiles].map((fileName, index) => (
                <img
                  key={`${fileName}-${index}`}
                  src={`/Brand_Logos/${fileName}`}
                  alt="Brand logo"
                  className="brand-logos-image"
                  loading="lazy"
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="divider" />

      <section className="problems">
        <div className="section-inner">
          <div className="problems-layout">
            <div className="problem-cards">
              <div className="problem-card reveal">
                <div className="problem-icon">📅</div>
                <div>
                  <h4>Manual Booking Management</h4>
                  <p>
                    Spreadsheets, DMs, and email threads consuming hours of your
                    day instead of growing your brand.
                  </p>
                </div>
              </div>
              <div className="problem-card reveal reveal-delay-1">
                <div className="problem-icon">🗂️</div>
                <div>
                  <h4>Inventory Availability Chaos</h4>
                  <p>
                    Double bookings, manual tracking, and frustrated customers
                    finding items unavailable at checkout.
                  </p>
                </div>
              </div>
              <div className="problem-card reveal reveal-delay-2">
                <div className="problem-icon">💬</div>
                <div>
                  <h4>Customer Communication Overload</h4>
                  <p>
                    Answering the same questions repeatedly - sizes,
                    availability, deposits, returns - draining your time.
                  </p>
                </div>
              </div>
              <div className="problem-card reveal reveal-delay-3">
                <div className="problem-icon">📉</div>
                <div>
                  <h4>Low Website Conversion Rates</h4>
                  <p>
                    Visitors browsing but not booking. A beautiful collection
                    hidden behind a poor digital experience.
                  </p>
                </div>
              </div>
            </div>
            <div className="problems-right reveal">
              <div className="section-tag">The Challenge</div>
              <h2 className="section-title">
                Fashion Rental Brands Face <em>Unique</em> Digital Challenges
              </h2>
              <p className="solution-intro">
                The fashion rental model is fundamentally different from
                standard e-commerce. Inventory rotates, bookings require
                precision timing, customers expect luxury service, and
                operations must scale without proportional headcount increases.
                <br />
                <br />
                Generic web agencies don't understand these nuances. We do - and
                we've built the tools to solve them.
              </p>
              <a href="#services" className="btn-primary">
                See Our Solutions
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="services" id="services">
        <div className="section-inner">
          <div className="services-header">
            <div>
              <div className="section-tag">Our Services</div>
              <h2 className="section-title reveal services-title">
                Everything Your Rental Brand <em>Needs to Thrive</em>
              </h2>
            </div>
            <a href="#audit" className="btn-primary reveal reveal-delay-2">
              Start a Project
            </a>
          </div>
          <div className="services-grid">
            <div className="service-card reveal">
              <div className="service-num">01</div>
              <div className="service-icon">🖥️</div>
              <h3>Fashion Rental Website Development</h3>
              <p>
                Custom-built, luxury-grade websites designed specifically for
                fashion rental businesses. Shopify, custom CMS, or headless -
                built for conversions.
              </p>
              <a href="#services" className="service-link">
                Explore Service
              </a>
            </div>
            <div className="service-card reveal reveal-delay-1">
              <div className="service-num">02</div>
              <div className="service-icon">📆</div>
              <h3>Rental Booking System Development</h3>
              <p>
                Automated booking engines with real-time inventory, calendar
                management, deposit handling, and customer self-service portals.
              </p>
              <a href="#services" className="service-link">
                Explore Service
              </a>
            </div>
            <div className="service-card reveal reveal-delay-2">
              <div className="service-num">03</div>
              <div className="service-icon">🤖</div>
              <h3>AI Automation for Rental Businesses</h3>
              <p>
                AI-powered chatbots, automated customer journeys, smart
                follow-ups, and intelligent inventory management to run your
                business while you sleep.
              </p>
              <a href="#services" className="service-link">
                Explore Service
              </a>
            </div>
            <div className="service-card reveal reveal-delay-3">
              <div className="service-num">04</div>
              <div className="service-icon">🔍</div>
              <h3>SEO &amp; Growth for Rental Brands</h3>
              <p>
                Organic search strategies tailored to the rental market. Rank
                for the terms that bring high-intent customers ready to book.
              </p>
              <a href="#services" className="service-link">
                Explore Service
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="work" id="work">
        <div className="section-inner">
          <div className="work-header">
            <div>
              <div className="section-tag">Featured Work</div>
              <h2 className="section-title reveal">
                Brands We've <em>Elevated</em>
              </h2>
            </div>
            <a href="#work" className="btn-ghost work-link">
              All Case Studies
            </a>
          </div>
          <div className="work-grid">
            <div className="work-item reveal">
              <div className="work-bg wb1" />
              <div className="work-pattern" />
              <div className="work-label">
                <span>Elysian</span>
              </div>
              <div className="work-content">
                <div className="work-category">
                  Designer Dress Rental · Shopify
                </div>
                <h3>Elysian Atelier</h3>
                <p>340% increase in online bookings within 90 days of launch</p>
              </div>
            </div>
            <div className="work-item reveal reveal-delay-1">
              <div className="work-bg wb2" />
              <div className="work-pattern" />
              <div className="work-label">
                <span>Vault</span>
              </div>
              <div className="work-content">
                <div className="work-category">
                  Luxury Bag Rental · Custom Platform
                </div>
                <h3>The Vault Collective</h3>
                <p>
                  AI assistant handling 80% of customer enquiries automatically
                </p>
              </div>
            </div>
            <div className="work-item reveal reveal-delay-2">
              <div className="work-bg wb3" />
              <div className="work-pattern" />
              <div className="work-label">
                <span>Maison</span>
              </div>
              <div className="work-content">
                <div className="work-category">
                  Fashion Accessories · Booking System
                </div>
                <h3>Maison Rent</h3>
                <p>
                  Eliminated manual bookings entirely with end-to-end automation
                </p>
              </div>
            </div>
            <div className="work-item reveal reveal-delay-3">
              <div className="work-bg wb4" />
              <div className="work-pattern" />
              <div className="work-label">
                <span>Archive</span>
              </div>
              <div className="work-content">
                <div className="work-category">
                  Vintage Dress Rental · SEO &amp; Growth
                </div>
                <h3>Archive Studio</h3>
                <p>
                  First page rankings for 47 high-value search terms in 6 months
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our-work-section" id="our-work">
        <div className="section-inner">
          <div className="section-tag">Our Work</div>
          <h2 className="section-title reveal">
            Real Projects From <em>Previous Builds</em>
          </h2>

          <div className="our-work-list">
            {ourWorkProjects.map((project, index) => (
              <article
                key={project.title}
                className={`our-work-row reveal ${index % 2 === 1 ? "our-work-row-reverse" : ""}`}
              >
                <div className="our-work-copy">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit Project
                  </a>
                </div>
                <div className="our-work-media">
                  <img src={project.image} alt={project.title} loading="lazy" />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="process">
        <div className="section-inner">
          <div className="section-tag">How We Work</div>
          <h2 className="section-title reveal process-title">
            Our <em>Proven</em> Process
          </h2>
          <div className="process-grid">
            <div className="process-step reveal">
              <div className="step-dot" />
              <div className="step-num">01</div>
              <div className="step-title">Discovery</div>
              <p className="step-desc">
                Deep dive into your brand, audience, current operations, and
                competitive landscape. We learn everything before we build
                anything.
              </p>
            </div>
            <div className="process-step reveal reveal-delay-1">
              <div className="step-dot" />
              <div className="step-num">02</div>
              <div className="step-title">Strategy</div>
              <p className="step-desc">
                A tailored digital roadmap - technology stack, design direction,
                automation plan, and growth strategy built for your specific
                business.
              </p>
            </div>
            <div className="process-step reveal reveal-delay-2">
              <div className="step-dot" />
              <div className="step-num">03</div>
              <div className="step-title">Design &amp; Build</div>
              <p className="step-desc">
                Pixel-perfect design and production-grade development. We
                present, iterate, and perfect before a single line goes live.
              </p>
            </div>
            <div className="process-step reveal reveal-delay-3">
              <div className="step-dot" />
              <div className="step-num">04</div>
              <div className="step-title">Launch &amp; Optimise</div>
              <p className="step-desc">
                Meticulous launch process followed by ongoing performance
                monitoring, testing, and optimisation to continuously improve
                results.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="section-inner">
          <div className="section-tag">Client Stories</div>
          <h2 className="section-title reveal">
            What Our Clients <em>Say</em>
          </h2>
          <div className="testi-grid">
            {testimonialsData.map((testimonial, index) => {
              const revealClass =
                index % 3 === 0
                  ? "reveal"
                  : index % 3 === 1
                    ? "reveal reveal-delay-1"
                    : "reveal reveal-delay-2";

              return (
                <div
                  key={`${testimonial.name}-${index}`}
                  className={`testi-card ${revealClass}`}
                >
                  <div className="testi-stars">★★★★★</div>
                  <p className="testi-quote">{testimonial.quote}</p>
                  <div className="testi-author">
                    <div className="testi-avatar">{testimonial.avatar}</div>
                    <div>
                      <div className="testi-name">{testimonial.name}</div>
                      <div className="testi-role">{testimonial.role}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="about-strip" id="about">
        <div className="section-inner">
          <div className="about-grid">
            <div className="about-left reveal">
              <div className="section-tag">About Pinnacle Route</div>
              <h2 className="section-title">
                The Digital Partner Built for <em>Fashion Rental</em>
              </h2>
              <p className="about-text">
                Pinnacle Route was founded with one purpose: to give fashion
                rental brands the same calibre of digital infrastructure that
                global luxury houses enjoy - at a scale that works for ambitious
                independent brands.
              </p>
              <p className="about-text">
                We combine luxury design sensibility with engineering rigour and
                AI innovation. Every project is led by specialists who have
                worked exclusively in the fashion rental space.
              </p>
              <div className="about-values">
                <div className="value-item">
                  <h4>Specialisation</h4>
                  <p>
                    100% focused on fashion rental. Not a sideline - our entire
                    expertise.
                  </p>
                </div>
                <div className="value-item">
                  <h4>Excellence</h4>
                  <p>
                    Premium output on every project. We don't ship work we're
                    not proud of.
                  </p>
                </div>
                <div className="value-item">
                  <h4>Innovation</h4>
                  <p>
                    First movers in applying AI to fashion rental operations.
                  </p>
                </div>
                <div className="value-item">
                  <h4>Partnership</h4>
                  <p>
                    Long-term relationships built on results, not retainers for
                    the sake of it.
                  </p>
                </div>
              </div>
            </div>
            <div className="about-visual reveal reveal-delay-1">
              <p className="about-tagline">
                "We exist to make fashion rental businesses{" "}
                <span>undeniably</span> premium online."
              </p>
              <p className="about-since">- Pinnacle Route, Est. 2020</p>
            </div>
          </div>
        </div>
      </section>

      <section className="audit" id="audit">
        <div className="section-inner">
          <div className="audit-inner">
            <div className="audit-left reveal">
              <div className="section-tag">Free Offer</div>
              <h2 className="section-title">
                Get a Free <em>Website Audit</em>
              </h2>
              <p className="audit-desc">
                We'll review your current rental website and booking experience,
                then deliver a detailed expert report showing exactly where you
                are losing bookings and how to fix it.
              </p>
              <div className="audit-features">
                <div className="audit-feature">Conversion rate analysis</div>
                <div className="audit-feature">Booking flow review</div>
                <div className="audit-feature">UX &amp; design assessment</div>
                <div className="audit-feature">SEO visibility check</div>
                <div className="audit-feature">Competitor benchmarking</div>
                <div className="audit-feature">Prioritised recommendations</div>
              </div>
              <p className="audit-note">
                Delivered within 5 business days. No obligation. No pitch - just
                honest expert insight.
              </p>
            </div>
            <form
              className="audit-form reveal reveal-delay-1"
              onSubmit={handleAuditSubmit}
            >
              <div className="form-title">Request Your Free Audit</div>
              <div className="form-group">
                <label htmlFor="audit-name">Your Name</label>
                <input
                  id="audit-name"
                  name="name"
                  type="text"
                  placeholder="Alexandra Laurent"
                  value={auditFormData.name}
                  onChange={handleAuditInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="audit-business">Business Name</label>
                <input
                  id="audit-business"
                  name="business"
                  type="text"
                  placeholder="Your Fashion Rental Brand"
                  value={auditFormData.business}
                  onChange={handleAuditInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="audit-url">Website URL</label>
                <input
                  id="audit-url"
                  name="website"
                  type="url"
                  placeholder="https://yourrentalsite.com"
                  value={auditFormData.website}
                  onChange={handleAuditInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="audit-email">Email Address</label>
                <input
                  id="audit-email"
                  name="email"
                  type="email"
                  placeholder="hello@yourbrand.com"
                  value={auditFormData.email}
                  onChange={handleAuditInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="audit-message">Message (optional)</label>
                <textarea
                  id="audit-message"
                  name="message"
                  placeholder="Tell us about your specific needs or questions..."
                  rows="4"
                  value={auditFormData.message}
                  onChange={handleAuditInputChange}
                />
              </div>

              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LfdYVYrAAAAADuAW-DHihyUwvCQRIUWXWdL5r2V"
                onChange={handleAuditCaptchaChange}
                onExpired={() => setAuditRecaptchaToken("")}
              />

              <button
                type="submit"
                className={`btn-form ${isAuditRequested ? "btn-form-submitted" : ""}`}
                disabled={isAuditRequested || isSubmittingAudit}
              >
                {isAuditRequested
                  ? "✓ Audit Requested — We'll be in touch within 24h"
                  : isSubmittingAudit
                    ? "Submitting..."
                    : "Request Free Audit →"}
              </button>
              {auditError && <p className="audit-form-error">{auditError}</p>}
            </form>
          </div>
        </div>
      </section>

      <section className="final-cta" id="contact">
        <div className="cta-eyebrow">Ready to Begin?</div>
        <h2 className="cta-title">
          Ready to Grow Your <em>Fashion Rental</em> Business Online?
        </h2>
        <div className="cta-actions">
          <a
            href={whatsappStrategyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Book Free Strategy Call
          </a>
          <a href="#work" className="btn-ghost final-cta-ghost">
            View Our Work
          </a>
        </div>
      </section>

      <footer>
        <div className="footer-inner">
          <div className="footer-top">
            <div className="footer-brand">
              <a href="#home" className="nav-logo">
                Pinnacle<span>Route</span>
              </a>
              <p>
                Pinnacle Route helps fashion rental businesses build premium
                websites, automated booking systems, and AI-powered digital
                operations.
              </p>
            </div>
            <div className="footer-col">
              <h5>Services</h5>
              <ul>
                <li>
                  <a href="#services">Website Development</a>
                </li>
                <li>
                  <a href="#services">Booking Systems</a>
                </li>
                <li>
                  <a href="#services">AI Automation</a>
                </li>
                <li>
                  <a href="#services">SEO &amp; Growth</a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h5>Company</h5>
              <ul>
                <li>
                  <a href="#about">About Us</a>
                </li>
                <li>
                  <a href="#work">Case Studies</a>
                </li>
                <li>
                  <a href="#home">Process</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h5>Get Started</h5>
              <ul>
                <li>
                  <a href="#audit">Free Website Audit</a>
                </li>
                <li>
                  <a href="#audit">Book Strategy Call</a>
                </li>
                <li>
                  <a href="mailto:info@pinnacleroute.com">
                    info@pinnacleroute.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-copy">
              © {currentYear} Pinnacle Route. All rights reserved.
            </div>
            <div className="social-links">
              <a
                href="https://www.instagram.com/pinnacle_route/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram aria-hidden="true" />
                Instagram
              </a>
              <a
                href="https://www.linkedin.com/in/pinnacle-route/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn aria-hidden="true" />
                LinkedIn
              </a>
              <a
                href="https://x.com/PinnacleRoute"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter aria-hidden="true" />
                Twitter
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
